import { render, staticRenderFns } from "./relyOn.vue?vue&type=template&id=6bc9470f"
import script from "./relyOn.vue?vue&type=script&lang=js"
export * from "./relyOn.vue?vue&type=script&lang=js"
import style0 from "./relyOn.vue?vue&type=style&index=0&id=6bc9470f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports